import { InjectionToken } from '@angular/core';

/**
 * Standardized audit source values for the X-Audit-Source HTTP header.
 * Used by the audit-source interceptor to identify which portal initiated the request.
 */
export type AuditSourceValue =
  | 'Client Portal'
  | 'Attorney Portal'
  | 'Member Portal';

/**
 * Injection token for the audit source value.
 * Each app provides its value at bootstrap (e.g. 'Client Portal' for hr-portal).
 */
export const AUDIT_SOURCE = new InjectionToken<AuditSourceValue>('AUDIT_SOURCE');
